import 'BomdisoftTheme/tokens.css';
import 'BomdisoftComponents/theme/baseline.css';
import 'BomdisoftComponents/theme/clepit.css';
import { toSafePrimaryColor, toThemeOverrideRule } from 'BomdisoftComponents/theme/render';
import type { ReactNode } from 'react';

export type ThemeProviderProps = {
  children: ReactNode;
  /** Overrides `--bomdisoft-primary` in both schemes (a product/tenant brand colour). */
  primaryColor?: string;
};

export const ThemeProvider = ({ children, primaryColor }: ThemeProviderProps) => {
  const safePrimaryColor = toSafePrimaryColor(primaryColor);

  return (
    <>
      {/* `html:root` outranks tokens.css's bare `:root` on specificity, applying the brand color
          on first paint via SSR'd CSS instead of waiting for a post-hydration effect. */}
      {safePrimaryColor && <style dangerouslySetInnerHTML={{ __html: toThemeOverrideRule(safePrimaryColor) }} suppressHydrationWarning />}
      {children}
    </>
  );
};
